import { AnswerStatuses, TAnswerStatuses } from "../utils";

export const getConfirmationClassName = (confirmationStatus: TAnswerStatuses) => {
  if (
    confirmationStatus === AnswerStatuses.ACCEPTED || 
    confirmationStatus === AnswerStatuses.COUNTER_OFFER_ACCEPTED
  ) {
    return 'accepted';
  } 
  if (confirmationStatus === AnswerStatuses.CANCELED) 
    return 'rejected';
  if (confirmationStatus === AnswerStatuses.COUNTER_OFFER_REJECTED) 
    return 'offer-rejected';
  if (confirmationStatus === AnswerStatuses.NO_RESPONSE) 
    return 'no-response';
  if (confirmationStatus === AnswerStatuses.COUNTER_OFFER) 
    return 'offer-time';
  return 'no-display';
}